module.exports = __webpack_public_path__ + "img/ds.646545fd.png";